/* Mega Metals — store picker
 * Persists the chosen store to localStorage and broadcasts
 * `mm:storechange` so other components (e.g. per-store stock on the
 * product page) can react without a page reload.
 */
(function () {
  var STORAGE_KEY = 'mm_store';
  var CONFIRMED_KEY = 'mm_store_confirmed';

  /* Sets the active store + broadcasts the change. Shared by the header
     dropdown and the first-visit modal so both stay in sync. */
  function setStore(store, opts) {
    opts = opts || {};
    window.localStorage.setItem(STORAGE_KEY, store);
    if (!opts.silent) {
      window.dispatchEvent(new CustomEvent('mm:storechange', { detail: { store: store } }));
    }
  }

  function initStorePicker(root) {
    var btn = root.querySelector('[data-mm-store-btn]');
    var menu = root.querySelector('[data-mm-store-menu]');
    var label = root.querySelector('[data-mm-store-label]');
    if (!btn || !menu || !label) return;

    var options = Array.prototype.slice.call(menu.querySelectorAll('[data-store]'));
    var defaultStore = (root.dataset.mmDefaultStore || (options[0] && options[0].dataset.store) || '').trim();
    var current = window.localStorage.getItem(STORAGE_KEY) || defaultStore;

    function updateUI(store) {
      current = store;
      label.textContent = store;
      options.forEach(function (opt) {
        opt.setAttribute('aria-selected', opt.dataset.store === store ? 'true' : 'false');
      });
    }

    function closeMenu() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        setStore(opt.dataset.store);
        window.localStorage.setItem(CONFIRMED_KEY, '1');
        closeMenu();
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    window.addEventListener('mm:storechange', function (e) {
      updateUI(e.detail.store);
    });

    updateUI(current);
    setStore(current, { silent: true });
  }

  /* First-visit modal — forces a store choice before browsing, unless
     the customer has already confirmed one (mm_store_confirmed flag,
     separate from mm_store itself so the picker's own silent default
     above never counts as a confirmed choice). */
  function initFirstVisitModal() {
    var modal = document.querySelector('[data-mm-store-modal]');
    if (!modal) return;
    if (window.localStorage.getItem(CONFIRMED_KEY)) return;

    modal.hidden = false;
    document.documentElement.classList.add('mm-modal-open');

    var buttons = modal.querySelectorAll('[data-store]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setStore(btn.dataset.store);
        window.localStorage.setItem(CONFIRMED_KEY, '1');
        modal.hidden = true;
        document.documentElement.classList.remove('mm-modal-open');
      });
    });
  }

  function initPhoneDisplays() {
    var links = document.querySelectorAll('[data-mm-phone-link]');
    if (!links.length) return;

    var mapEl = document.querySelector('[data-mm-store-phones]');
    var phoneMap = {};
    if (mapEl) {
      try {
        phoneMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        phoneMap = {};
      }
    }

    function updatePhones(store) {
      var phone = phoneMap[store];
      if (!phone) return;
      links.forEach(function (link) {
        link.setAttribute('href', 'tel:' + phone.replace(/\s+/g, ''));
        var textEl = link.querySelector('[data-mm-phone-text]');
        if (textEl) textEl.textContent = phone;
      });
    }

    var current = window.localStorage.getItem(STORAGE_KEY);
    if (current) updatePhones(current);

    window.addEventListener('mm:storechange', function (e) {
      updatePhones(e.detail.store);
    });
  }

  document.querySelectorAll('[data-mm-store-picker]').forEach(initStorePicker);
  initFirstVisitModal();
  initPhoneDisplays();
})();
